module.exports = __webpack_public_path__ + "html/tagger.0a9d72.html";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Forms/tagger.html
 ** module id = 526
 ** module chunks = 0 1 2 3 5 11
 **/